// extracted by mini-css-extract-plugin
export default {"icon":"OzhlD","reversedIcon":"MND5y","overflow":"qtR3O","title":"Q5AhO","mobile":"ljb68","listContentTitleColor":"sis-6"};